import React from 'react';

function Subscriptions() {
  return <div>subscriptions</div>;
}

export default Subscriptions;
